import { defineStore } from 'pinia';

export const useUserDetailsStore = defineStore({
  id: 'userDetailsStore',
  state: () => {
    return {
      user: null,
    };
  },
  actions: {
    async getUserDetails() {
      let user = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        this.user = user.data;
        localStorage.removeItem('user');
        return;
      }
      const { data, pending, error } = await useAcvFetch(
        `api/user/userdetails`
      );

      if (error.value) {
        return {
          status: error.value.statusCode,
        };
      }
      this.user = data.value.data;
      return { user: data.value.data, pending };
    },
  },
  getters: {
    carrier: (state) => state.user?.carrier,
    role: (state) => state.user?.role,
    userName: (state) => state.user?.userName,
    userID: (state) => state.user?.transUserId,
    carrierID: (state) =>
      state.user?.carrier?.sfId ? state.user?.carrier?.sfId : state.user?.sfId, // adding this conditional to guard against the case where the carrier object has NOT been linked to the user
    currentUserInitials: (state) => state.user?.userName.slice(0, 1),
    companyName: (state) => state.user?.name,
    maxJobCount: (state) => state.user?.carrier?.maxJobCount,
    currentJobCount: (state) => state.user?.carrier?.currentJobCount,
    postalCode: (state) => state.user?.carrier?.postalCode,
    email: (state) => state.user?.email,
    termsAccepted: (state) => state.user?.termsAccepted,
    amName: (state) => state.user?.carrier?.amName,
    amPhone: (state) => state.user?.carrier?.amPhone,
    amEmail: (state) => state.user?.carrier?.amEmail,
    accountLevel: (state) => state.user?.carrier.accountLevel,
    phone: (state) => state.user?.phone,
  },
});
